import * as React from "react";
import { cn } from "../../lib/utils";
import { Eyebrow } from "../atoms/eyebrow";
import { DisplayHeading } from "../atoms/display-heading";

export interface PanelHeaderProps
	extends Omit<React.HTMLAttributes<HTMLDivElement>, "title"> {
	eyebrow?: React.ReactNode;
	heading: React.ReactNode;
	meta?: React.ReactNode;
	actions?: React.ReactNode;
}

const PanelHeader = React.forwardRef<HTMLDivElement, PanelHeaderProps>(
	({ className, eyebrow, heading, meta, actions, ...props }, ref) => {
		return (
			<div
				ref={ref}
				className={cn(
					"flex-shrink-0 px-3.5 py-2.5 border-b border-gray-200/80 dark:border-white/[0.06] " +
						"bg-white/80 dark:bg-[#0c0c0e]/80 backdrop-blur-md",
					className,
				)}
				{...props}
			>
				<div className="flex items-center justify-between gap-3 min-w-0">
					<div className="flex items-baseline gap-2 min-w-0">
						{eyebrow && <Eyebrow className="!text-[9px]">{eyebrow}</Eyebrow>}
						<DisplayHeading size="sm" className="!text-[15px] truncate">
							{heading}
						</DisplayHeading>
						{meta && (
							<div className="text-[10px] tabular text-gray-500 dark:text-gray-500 truncate">
								{meta}
							</div>
						)}
					</div>
					{actions && (
						<div className="flex items-center gap-0.5 flex-shrink-0">{actions}</div>
					)}
				</div>
			</div>
		);
	},
);
PanelHeader.displayName = "PanelHeader";

export { PanelHeader };
